import { Application, EventEmitter, Renderer, RenderLayer } from "pixi.js";
import { CommonEvents, GameEvents, MessageEvents } from "../events/EventEnums";
import { JackpotHitData } from "../models/JackpotHitData";
import JackpotHistory from "../components/JackpotHistory";

const GlobalStore = (() => {
  const layers: Record<string, RenderLayer> = {
    background: new RenderLayer(),
    content: new RenderLayer(),
    loader: new RenderLayer(),
    debug: new RenderLayer({
      sortableChildren: true,
    }),
  };

  let _app: Application<Renderer> | null = null;
  let _language: string = "";
  let _theme: string = "";
  let _ip: string = "";
  let _port: number = 0;
  let _jackpotHit: JackpotHitData | null = null;
  let _signId: string = "";
  let _JackpotHistory: JackpotHitData[] = [];

  const commonEventEmitter: EventEmitter<
    (typeof CommonEvents)[keyof typeof CommonEvents]
  > = new EventEmitter();
  const messageEventEmitter: EventEmitter<
    (typeof MessageEvents)[keyof typeof MessageEvents]
  > = new EventEmitter();
  const gameEventEmitter: EventEmitter<
    (typeof GameEvents)[keyof typeof GameEvents]
  > = new EventEmitter();

  return {
    layers,
    commonEventEmitter,
    messageEventEmitter,
    gameEventEmitter,

    getApp: () => _app,
    setApp: (app: Application<Renderer>) => {
      _app = app;
    },

    getLanguage: () => _language,
    setLanguage: (lang: string) => {
      _language = lang;
      commonEventEmitter.emit(CommonEvents.CHANGE_LANGUAGE, lang);
    },

    getTheme: () => _theme,
    setTheme: (theme: string) => {
      _theme = theme;
      commonEventEmitter.emit(CommonEvents.CHANGE_THEME, theme);
    },

    getIP: () => _ip,
    setIP: (ip: string) => {
      _ip = ip;
    },

    getPort: () => _port,
    setPort: (port: number) => {
      _port = port;
    },

    setJackpotHitData: (data: JackpotHitData | null) => {
      _jackpotHit = data;
    },
    getJackpotHitData: (): JackpotHitData | null =>
      _jackpotHit ? { ..._jackpotHit } : null,

    setSignId: (signId: string): void => {
      _signId = signId;
    },
    getSignId: (): string => `${_signId}`,

    setJackpotHistory: (history: JackpotHitData[]) => {
      _JackpotHistory = [...history];
    },
    getJackpotHistory: (): JackpotHitData[] => [..._JackpotHistory],
  };
})();

export default GlobalStore;
